import { createReducer, on } from '@ngrx/store';
import { initialProviderState, ProviderState } from './provider.state';
import {
    loadProviders, loadProvidersSuccess, loadProvidersFailure,
    addProvider, addProviderSuccess, addProviderFailure,
    updateProvider, updateProviderSuccess, updateProviderFailure,
    deleteProvider, deleteProviderSuccess, deleteProviderFailure,
} from './provider.actions';

export const providerReducer = createReducer(
    initialProviderState,

    on(loadProviders, (state): ProviderState => ({ ...state, loading: true, error: null })),
    on(loadProvidersSuccess, (state, { items }): ProviderState => ({
        ...state, items, loaded: true, loading: false,
    })),
    on(loadProvidersFailure, (state, { error }): ProviderState => ({ ...state, error, loading: false })),

    on(addProvider, (state): ProviderState => ({ ...state, loading: true, error: null })),
    on(addProviderSuccess, (state, { item }): ProviderState => ({
        ...state, items: [...state.items, item], loading: false,
    })),
    on(addProviderFailure, (state, { error }): ProviderState => ({ ...state, error, loading: false })),

    on(updateProvider, (state): ProviderState => ({ ...state, loading: true, error: null })),
    on(updateProviderSuccess, (state, { item }): ProviderState => ({
        ...state,
        loading: false,
        items: state.items.map(i => i.supplierId === item.supplierId ? item : i),
    })),
    on(updateProviderFailure, (state, { error }): ProviderState => ({ ...state, error, loading: false })),

    on(deleteProvider, (state): ProviderState => ({ ...state, loading: true, error: null })),
    on(deleteProviderSuccess, (state, { id }): ProviderState => ({
        ...state,
        loading: false,
        items: state.items.filter(i => i.supplierId !== id),
    })),
    on(deleteProviderFailure, (state, { error }): ProviderState => ({ ...state, error, loading: false })),
);
